import React from 'react';
import { Activity, Trophy, Users, BookOpen, Brain, Film } from 'lucide-react';
import FeatureCard from './FeatureCard';

const FeaturesSection = () => {
  const features = [
    {
      icon: Activity,
      title: 'Performance Analytics',
      description: 'Visualize your win rates, performance trends, and cumulative stats with interactive charts and real-time tracking.'
    },
    {
      icon: Brain,
      title: 'AI Video Coach',
      description: 'Upload match footage and get instant AI-powered technique feedback. Analyzes footwork, racket position, and body posture.'
    },
    {
      icon: BookOpen,
      title: 'Training Diary',
      description: 'Log what you learned after every session. Track improvements, set goals, and build consistent training habits.'
    },
    {
      icon: Trophy,
      title: 'Match History',
      description: 'Keep a detailed log of every game with scores, opponents, and video highlights. Filter by date, opponent, or type.'
    },
    {
      icon: Film,
      title: 'Short Highlights',
      description: 'Share your best rallies and match moments as short-form videos with the badminton community.'
    },
    {
      icon: Users,
      title: 'Social & Friends',
      description: 'Find and challenge other players, compare stats, get friend recommendations, and climb the leaderboard.'
    }
  ];

  return (
    <section className="w-full bg-white py-24" aria-label="Features">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Everything you need to improve
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            From match tracking to AI coaching — the complete toolkit for badminton players who want to level up their game.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
